var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M882.915556 753.208889c-56.888889-43.235556-218.453333-118.328889-218.453334-118.328889l-104.675555 195.697778-15.928889-45.511111 29.582222-59.164445-56.888889-59.164444-61.44 59.164444 29.582222 59.164445-18.204444 47.786666L364.088889 637.155556s-163.84 72.817778-218.453333 118.328888C88.746667 798.72 63.715556 932.977778 63.715556 932.977778h905.671111c-2.275556-2.275556-20.48-127.431111-86.471111-179.768889m-364.088889-134.257778c131.982222 0 220.728889-177.493333 220.728889-273.066667s0-263.964444-220.728889-263.964444-220.728889 168.391111-220.728889 263.964444 88.746667 273.066667 220.728889 273.066667",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent11);
export default __webpack_public_path__ + "static/media/agent-11.f25b00b22879e2e0ad960138ccd8615d.svg";
export { ForwardRef as ReactComponent };